module.exports = __webpack_public_path__ + "img/wenhua.d014b8d6.jpg";